import { observer } from "mobx-react";
import { FC, useEffect } from "react";
import { SplitShareForm } from "./splitShareDomain";
import { anyValidSplit } from "../../utils/shareSplits";
import { ArticleSelectorQuestion, NumberField } from "../common/commonComponents";
import { Alert } from "../../components-v2/Alert";
import { Box, VBox } from "../../components-v2/Box";
import { TextInput } from "../../components-v2/TextInput";
import { CURRENCY_NOK } from "../../utils/currency";

import { useTranslation } from "../../stores/RootStoreContext";

export const SplitShareView: FC<{ form: SplitShareForm }> = observer(({ form }) => {
  const { t } = useTranslation();

  useEffect(() => form.init(), [form]);

  return (
    <VBox gap={"md"}>
      <NumberField
        field={form.ratio}
        onChange={(e) => form.setSplitRatio(e.target.value)}
        label={t("decisions.shareSplits.split.ratio")}
        isLocked={form.isProjectLocked}
        inline
      />
      <TextInput
        label={t("decisions.shareSplits.current-nominal")}
        prefix={CURRENCY_NOK}
        value={form.currentNominalValue}
        disabled
        inline
      />
      <Box>
        <TextInput
          label={t("decisions.shareSplits.new-nominal")}
          prefix={CURRENCY_NOK}
          value={form.newNominalValue}
          disabled
          inline
        />
      </Box>
      {form.showSplitIntoOneMessage && (
        <Alert type="warning" message={t("decisions.shareSplits.split.helperText-splitIntoOne")} />
      )}
      {!anyValidSplit(form.currentNominalValue) && (
        <Alert type="warning" message={t("decisions.shareSplits.split.helperText-noavoid")} />
      )}
      {form.invalidSplitMessage && <Alert type="warning" message={t(form.invalidSplitMessage)} />}
      <ArticleSelectorQuestion
        question={t("decisions.shareSplits.which-paragraph")}
        model={form.shareCapitalParagraph}
        isLocked={form.isProjectLocked}
      />
    </VBox>
  );
});
